import { motion } from "framer-motion";

export default function PageHero({ kicker, title, accent, children }) {
  return (
    <section data-testid="page-hero" className="relative bg-oxblood pt-40 pb-20 md:pt-52 md:pb-28 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse 60% 50% at 25% 35%, rgba(221,194,140,0.09), transparent 65%)" }}
      />
      {accent ? (
        <span
          className="absolute -right-8 -bottom-20 font-display text-outline-ivory text-[22vw] leading-none select-none pointer-events-none"
          aria-hidden
        >
          {accent}
        </span>
      ) : null}
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 relative">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="text-brass-soft text-xs tracking-[0.45em] uppercase mb-6"
        >
          {kicker}
        </motion.p>
        <span className="block overflow-hidden pb-2">
          <motion.h1
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="font-display text-ivory text-5xl md:text-7xl leading-[1.05] max-w-4xl"
          >
            {title}
          </motion.h1>
        </span>
        {children ? (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            {children}
          </motion.div>
        ) : null}
      </div>
    </section>
  );
}
